import axios from 'axios'
import tokenConfig from '../common/config'
import qs from 'qs'
import { Message, Loading } from 'element-ui'
import router from '../router'
import Cookies from 'js-cookie'


const urlencoded = 'application/x-www-form-urlencoded;charset=UTF-8'
const formData = 'multipart/form-data'
const json = 'application/json;charset=UTF-8'

axios.defaults.headers.common['Cache-Control'] = 'no-cache'
axios.defaults.headers.common['Pragma'] = 'no-cache'
axios.defaults.headers.common['Content-Type'] = json
// axios.defaults.headers.common['access-token'] = tokenConfig.accessToken ? tokenConfig.accessToken : ''
axios.defaults.withCredentials = false
axios.defaults.timeout = 300000 // 超时时间120秒
// loading对象
let loadingInstance
// 正在请求的数量
let isLoadindCount = 0
const options = {
  fullscreen: true,
  background: 'rgba(255,255,255,.5)',
  // text: 'Loading', // 显示在加载图标下方的加载文案
  spinner: '', // 自定义加载图标类名
  customClass: '' // Loading 的自定义类名
}

// 显示loading
function showLoading (text = '') {
  if (isLoadindCount === 0 && !loadingInstance) {
    const _options = JSON.parse(JSON.stringify(options))
    const word = window.ENi18n.messages[window.ENi18n.locale].globalLoading || 'Loading'
    _options.text = text || word
    loadingInstance = Loading.service(_options)
  }
  isLoadindCount++
}

// 关闭loading+防抖
const doCloseLoading = debounce(() => {
  if (loadingInstance) {
    loadingInstance.close()
    loadingInstance = null
  }
}, 300)

// 关闭loading
function closeLoading () {
  isLoadindCount--
  isLoadindCount = Math.max(isLoadindCount, 0) // 避免数值错误
  if (isLoadindCount === 0) {
    doCloseLoading()
  }
}

// 函数防抖
function debounce(fn, interval = 300) {
  let timeout = null
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn.apply(this, arguments)
    }, interval)
  }
}

axios.interceptors.request.use(
  config => {
    config.headers.common['access-token'] = Cookies.get(tokenConfig.tokenName)
    let text = ''
    if (config.data) {
      if (config.headers['Content-Type'].indexOf('form-data') > -1) {
        text = config.data.get('loadingText') // formdata
      } else {
        text = config.data.loadingText
      }
    }
    showLoading(text)
    if (config.headers['Content-Type'].indexOf('json') > -1 || config.headers['Content-Type'].indexOf('form-data') > -1) {
      return config
    }
    config.data = qs.stringify(config.data)
    // loadingInstance = Loading.service(options)
    return config
  }
)


axios.interceptors.response.use(
  (response, reject) => {
    // loadingInstance.close()
    closeLoading()
    const res = response.data
    // if (res && (res.code !== 1)) {
    // if () {
    // }
    if (res && (res.code !== 1)) {
      Message.error(res.message)
      Promise.reject(res) // 是否需要reject
    } else {
      return res
    }
  },
  error => {
    // loadingInstance.close()
    closeLoading()
    const { response } = error
    Message.error(response.data.message ? response.data.message : response.statusText)
    if (+response.status === 405) {
      const identityInvalid = window.ENi18n.messages[window.ENi18n.locale].identityInvalid || 'Identity information is invalid, please login again'
      Message.error(identityInvalid)
      setTimeout(() => {
        router.push('/')
        setTimeout(() => {
          window.location.reload()
        }, 100)
      }, 1500)
    }
    return Promise.reject(error)
  }
)

const urlHeader = {
  'Content-Type': urlencoded
}

const jsonHeader = {
  'Content-Type': json
}

const formDataHeader = {
  'Content-Type': formData
}
const publicPath = location.origin

const language = Cookies.get(tokenConfig.language)
let languageUrl = 'en_US'
if (language === 'spanish') {
  languageUrl = 'es_ES'
} else if (language === 'portuguese') {
  languageUrl = 'pt_PT'
}

function fetch (data) {
  return new Promise((resolve, reject) => {
    axios.request({
      url: `${publicPath}/${data.url}?language=${languageUrl}`,
      method: data.method,
      [data.method === 'get' ? 'params' : 'data']: data.params,
      headers: data.headerType === 'json' ? jsonHeader : data.headerType === 'formdata' ? formDataHeader : urlHeader // content type
      // responseType: data.responseType ? data.responseType : 'json'
    })
      .then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
      .catch(error => {
        reject(error)
      })
  })
}
export default {
  get (url, data, type) { // url: 请求路径, data: 参数， type: json为json, formData为formdata, 默认不传为urlencoded
    return fetch({ url: url, method: 'get', params: data, headerType: type })
  },
  post (url, data, type) {
    return fetch({ url: url, method: 'post', params: data, headerType: type })
  }
}
